import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const getPricingPackages = async ({
  packageId,
  coupon,
}: {
  packageId: string;
  coupon?: string;
}) => {
  const params: Record<string, string> = {};

  if (coupon) {
    params['coupon'] = coupon;
  }

  return (
    await companyCreationAxiosInstance.get(
      `v1/customer/pricing-packages/${packageId}/pricing`,
      { params }
    )
  ).data;
};
